<template>
  <div class="b-datepicker">
    <div class="b-datepicker__button">
      {{ label }}

      <div class="b-datepicker__calendar">
        <span class="icon-calendar"></span>
        <input
          ref="inputDateFrom"
          type="text"
          readonly
          class="input date-input"
          autocomplete="off" />
      </div>
    </div>
  </div>
</template>

<script>
import { Datepicker } from 'jquery-ui/ui/widgets/datepicker'

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputFrom: null,
    }
  },

  mounted() {
    this.inputFrom = jQuery(this.$refs.inputDateFrom)

    this.$nextTick(function () {
      this.iniDatepicker()
    })
  },

  methods: {
    iniDatepicker() {
      this.inputFrom.datepicker({
        minDate: new Date(this.dateFrom),
        maxDate: new Date(this.dateTo),
        dateFormat: 'dd/mm/yy',
        onSelect: () => {
          this.$emit('changed-date', this.formattedDate(this.inputFrom.datepicker('getDate')))
        },
      })
    },

    formattedDate(today) {
      const yyyy = today.getFullYear()
      let mm = today.getMonth() + 1
      let dd = today.getDate()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm
      return yyyy + '-' + mm + '-' + dd
    },
  },
}
</script>
